// src/pages/Cart.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Cart() {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(stored);
  }, []);

  const changeQty = (idx, delta) => {
    setCart(prev => {
      const copy = [...prev];
      copy[idx].qty = Math.max(1, (copy[idx].qty || 1) + delta);
      localStorage.setItem("cart", JSON.stringify(copy));
      return copy;
    });
  };

  const removeItem = (idx) => {
    setCart(prev => {
      const copy = prev.filter((_, i) => i !== idx);
      localStorage.setItem("cart", JSON.stringify(copy));
      return copy;
    });
  };

  const clearCart = () => {
    localStorage.removeItem("cart");
    setCart([]);
  };

  const total = cart.reduce((s, it) => s + (Number(it.price || 0) * Number(it.qty || 1)), 0);

  return (
    <main style={{ maxWidth: 900, margin: "20px auto", padding: 16 }}>
      <h2 style={{ textAlign: "center", marginBottom: 18 }}>🛒 Your Cart</h2>

      {cart.length === 0 ? (
        <div style={{ textAlign: "center", padding: 30 }}>
          Your cart is empty. <Link to="/products">Browse products</Link>
        </div>
      ) : (
        <>
          <div style={{ display: "grid", gap: 12 }}>
            {cart.map((item, idx) => (
              <div key={idx} style={{
                border: "1px solid #eee",
                padding: 16,
                borderRadius: 8,
                display: "flex",
                gap: 12,
                alignItems: "center",
                flexWrap: "wrap"
              }}>
                <div style={{ flex: "0 0 90px" }}>
                  <img
                    src={item.image || "/images/placeholder.jpg"}
                    alt={item.name}
                    style={{ width: 90, height: 90, objectFit: "cover", borderRadius: 6 }}
                    onError={(e) => { e.currentTarget.src = "/images/placeholder.jpg"; }}
                  />
                </div>

                <div style={{ flex: "1 1 auto", minWidth: 200 }}>
                  <h3 style={{ margin: "4px 0" }}>{item.name}</h3>
                  <div style={{ color: "#555", fontSize: 14 }}>Category: {item.category || "—"}</div>
                  <div style={{ color: "#555", fontSize: 14 }}>Size: {item.size || "—"}</div>
                  <div style={{ marginTop: 8, fontWeight: 700 }}>Price: ₹{item.price}</div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "center" }}>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <button onClick={() => changeQty(idx, -1)} aria-label="Decrease quantity">-</button>
                    <div style={{ minWidth: 30, textAlign: "center" }}>{item.qty || 1}</div>
                    <button onClick={() => changeQty(idx, +1)} aria-label="Increase quantity">+</button>
                  </div>

                  <button
                    onClick={() => removeItem(idx)}
                    style={{ background: "#e74c3c", color: "#fff", border: "none", padding: "6px 10px", borderRadius: 6 }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <h3>Total: ₹{total}</h3>

            <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 12 }}>
              <button
                onClick={() => navigate('/checkout', { state: { fromCart: true } })}
                style={{ padding: "10px 16px", background: "#111", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer" }}
              >
                Proceed to Checkout
              </button>

              <button
                onClick={clearCart}
                style={{ padding: "10px 16px", border: "1px solid #ddd", borderRadius: 8, background: "#fff", cursor: "pointer" }}
              >
                Clear Cart
              </button>
            </div>
          </div>
        </>
      )}
    </main>
  );
}

export default Cart;
